module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_vm._v("GREED IS THE COLOR OF GOLD: GOLD MINING IN CHARLOTTE’S EARLY HISTORY")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#sec1.1"
    }
  }, [_vm._v("The First Gold Rush In America")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#sec1.2"
    }
  }, [_vm._v("Crimes Associated With the Mines")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#sec1.3"
    }
  }, [_vm._v("The Charlotte Mint")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROBBERIES: HITTING CHARLOTTE IN THE POCKETBOOK")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#sec2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commando Gang Robs Belk’s")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#sec2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Loomis Fargo Theft")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#sec2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gangster Heist Defines Charlotte’s “Crime of the Century”")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE TASTE OF WHITE LIGHTNING: BOOTLEGGERS, SPEAKEASIES AND THE RISE OF NASCAR")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#sec3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bootlegging in the Piedmont")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#sec3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speakeasies in the Queen City")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#sec3.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rise of NASCAR")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCOUNDRELS, CADS AND MISBEHAVING WOMEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#sec4.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teenage Girl With Arson on Her Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#sec4.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jim Bakker: Greed and God in a Theme Park")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#sec4.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeanette Lark: A Public Prostitute")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#sec4.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ku Klux Klan: Rearing Its Ugly Head Early")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#sec4.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KKK’s September of 1957")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#sec4.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Targeting of Julius Chambers")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTORIOUS MURDERERS AND THEIR EVIL DEEDS")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#sec5.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Murder of Francis Bradley: The Strongest Patriot")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#sec5.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("W.J. Cash: Suicide or Murder?")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#sec5.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry Louis Wallace: The Charlotte Strangler")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#sec5.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rae Carruth: Pro Athlete and Murderer For Hire")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: “Sin With a Southern Accent” by Stephen Hull")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/references",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0